  function initStickyATC() {
    var bar = $('[data-bn-sticky-atc]');
    if (!bar || bar.__bnc) return; bar.__bnc = true;
    bar.removeAttribute('hidden');

    var target = $('#bn-buy') || $('.bn-pm') || $('[data-bn="product"]') || $('form[action*="/cart/add"]');
    var cta = $('[data-bn-scroll-to]', bar);
    if (cta && target) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
    // The bar ships visible. Hide it only while the product module is on
    // screen — the bar exists to get the reader there, so it is noise once
    // they have arrived. Failing open means it is never silently absent.
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { bar.classList.toggle('is-at-target', en.isIntersecting); });
      }, { threshold: 0.15 }).observe(target);
    }
  }

  /* Sizing pass for marquee tracks: duration scales with content width so a
     long row is not whipped across the screen. */
  function initMarqueeTracks() {
    $$('.rfm-marquee-container').forEach(function (c) {
      if (c.__bncMq) return; c.__bncMq = true;
      var w = c.scrollWidth || 2000;
      // ~60px/sec, then slowed 40% per the agreed pacing
      c.style.setProperty('--bnc-mq-duration', Math.max(24, Math.round((w / 60) / 0.6)) + 's');
    });
  }

/* Basis — native runtime for compiled sections.
 *
 * The compiled sections are plain HTML/CSS: layout, spacing, type and colour
 * all resolve from the stylesheet with no script running. This file adds only
 * behaviour, so with JavaScript disabled every section still renders its
 * content. That is the property the previous vendor architecture lacked, where
 * content shipped hidden and was revealed by the runtime.
 *
 * Elements are marked at compile time with data-bn-role.
 */
(function () {
  'use strict';
  if (window.__bncRuntime) return;          // sections may reference this once each
  window.__bncRuntime = true;

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------------- *
   * Lazy media. Loads on approach, with an unconditional backstop:
   * an IntersectionObserver alone leaves media unloaded inside
   * content-visibility subtrees and on fast scrolls.
   * ---------------------------------------------------------------- */
  function swapMedia(el) {
    if (el.hasAttribute('data-bnc-loaded')) return;
    var src = el.getAttribute('data-src');
    var set = el.getAttribute('data-srcset');
    if (set) el.setAttribute('srcset', set);
    if (src) el.setAttribute('src', src);
    el.setAttribute('data-bnc-loaded', '');
    if (el.tagName === 'VIDEO') {
      el.muted = true; el.playsInline = true; el.removeAttribute('controls');
      var go = function () { var p = el.play(); if (p && p.catch) p.catch(function () {}); };
      go(); el.addEventListener('canplay', go, { once: true });
    }
  }
  function initLazy() {
    var t = $$('[data-src]:not([data-bnc-loaded]),[data-srcset]:not([data-bnc-loaded])');
    if (!t.length) return;
    if (!('IntersectionObserver' in window)) { t.forEach(swapMedia); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { swapMedia(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '1200px 0px' });
    t.forEach(function (el) { io.observe(el); });
  }
  function loadRemaining() { $$('[data-src]:not([data-bnc-loaded]),[data-srcset]:not([data-bnc-loaded])').forEach(swapMedia); }

  /* ---------------------------------------------------------------- *
   * Carousels — CSS scroll-snap. Touch swipe and trackpad are native;
   * this adds mouse drag, arrows and keyboard.
   * ---------------------------------------------------------------- */
  function track(host) {
    var kids = $$(':scope > *', host);
    if (kids.length === 1 && kids[0].children.length > 1) return kids[0];
    return host;
  }
  function initCarousel(host) {
    if (host.__bnc) return; host.__bnc = true;
    var t = track(host);
    t.classList.add('bnc-track');
    var slides = function () { return $$(':scope > *', t); };
    var index = function () {
      var best = 0, d = Infinity;
      slides().forEach(function (s, i) {
        var x = Math.abs(s.offsetLeft - t.offsetLeft - t.scrollLeft);
        if (x < d) { d = x; best = i; }
      });
      return best;
    };
    var go = function (i) {
      var s = slides();
      i = Math.max(0, Math.min(s.length - 1, i));
      if (s[i]) t.scrollTo({ left: s[i].offsetLeft - t.offsetLeft, behavior: 'smooth' });
    };
    // mouse drag (touch is left to the browser, which does it better)
    var down = false, moved = false, x0 = 0, l0 = 0, pid = null;
    t.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button !== 0) return;
      down = true; moved = false; pid = e.pointerId; x0 = e.clientX; l0 = t.scrollLeft;
      t.classList.add('is-grabbing'); t.style.scrollSnapType = 'none';
    });
    t.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pid) return;
      var dx = e.clientX - x0;
      if (!moved && Math.abs(dx) > 4) { moved = true; try { t.setPointerCapture(pid); } catch (x) {} }
      if (!moved) return;
      e.preventDefault(); t.scrollLeft = l0 - dx;
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      t.addEventListener(ev, function () {
        if (!down) return;
        down = false; t.classList.remove('is-grabbing'); t.style.scrollSnapType = '';
        if (pid !== null) { try { t.releasePointerCapture(pid); } catch (x) {} }
        pid = null; if (moved) go(index());
      });
    });
    t.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    // arrows: whatever the builder emitted as prev/next
    var scope = host.closest('[data-bn]') || host;
    $$('[class*="arrow"],[class*="prev"],[class*="next"]', scope).forEach(function (b) {
      var next = /next|right/i.test(b.className);
      b.addEventListener('click', function (e) { e.preventDefault(); go(index() + (next ? 1 : -1)); });
    });
    t.setAttribute('tabindex', t.getAttribute('tabindex') || '0');
    t.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); go(index() - 1); }
    });
  }

  /* ---------------------------------------------------------------- *
   * Marquee — CSS animation, duplicated track for a seamless loop.
   * ---------------------------------------------------------------- */
  function initMarquee(host) {
    if (host.__bnc) return; host.__bnc = true;
    var row = $('.rfm-marquee, .bnc-marquee-row', host) || host.firstElementChild;
    if (!row) return;
    host.classList.add('bnc-mq');
    var w = row.scrollWidth || 1200;
    row.style.setProperty('--bnc-mq-duration', Math.max(20, w / 70 / 0.6) + 's');
  }

  /* ---------------------------------------------------------------- *
   * Accordion / tabs / dialog
   * ---------------------------------------------------------------- */
  function initAccordion(host) {
    if (host.__bnc) return; host.__bnc = true;
    $$('[class*="accordion-item"],[class*="collapse-item"]', host).forEach(function (item) {
      var head = item.firstElementChild, body = item.lastElementChild;
      if (!head || !body || head === body) return;
      head.setAttribute('role', 'button');
      head.setAttribute('tabindex', '0');
      var toggle = function () {
        var open = item.classList.toggle('is-open');
        body.style.display = open ? '' : 'none';
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      head.addEventListener('click', toggle);
      head.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });
  }
  function initTabs(host) {
    if (host.__bnc) return; host.__bnc = true;
    var labels = $$('[class*="tab-title"],[class*="tab-label"],[role="tab"]', host);
    var panes  = $$('[class*="tab-content"],[class*="tab-pane"],[role="tabpanel"]', host);
    if (!labels.length || !panes.length) return;
    labels.forEach(function (l, i) {
      l.addEventListener('click', function (e) {
        e.preventDefault();
        labels.forEach(function (x, n) { x.classList.toggle('is-active', n === i); });
        panes.forEach(function (p, n) { p.style.display = n === i ? '' : 'none'; });
      });
    });
  }
  function initDialog(host) {
    if (host.__bnc) return; host.__bnc = true;
    host.style.display = host.style.display || 'none';
    var id = host.id;
    if (id) {
      $$('[href="#' + id + '"],[data-bnc-open="' + id + '"]').forEach(function (o) {
        o.addEventListener('click', function (e) { e.preventDefault(); host.style.display = 'block'; });
      });
    }
    $$('[class*="close"]', host).forEach(function (c) {
      c.addEventListener('click', function (e) { e.preventDefault(); host.style.display = 'none'; });
    });
  }

  /* ---------------------------------------------------------------- *
   * YouTube facades — thumbnail until clicked, then the player.
   * ---------------------------------------------------------------- */
  function initYouTube(host) {
    if (host.__bnc) return; host.__bnc = true;
    var id = host.getAttribute('videoid') || host.getAttribute('data-videoid') ||
             (host.innerHTML.match(/[?&/](?:v=|embed\/)([A-Za-z0-9_-]{11})/) || [])[1];
    if (!id) return;
    host.style.cursor = 'pointer';
    host.addEventListener('click', function () {
      if (host.__played) return; host.__played = true;
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      f.title = 'Video'; f.loading = 'lazy';
      f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      f.setAttribute('allowfullscreen', '');
      f.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0';
      host.style.position = host.style.position || 'relative';
      host.innerHTML = ''; host.appendChild(f);
    });
  }

  /* ---------------------------------------------------------------- *
   * Add to cart. Routed through the theme's own addToCartAjax where it
   * exists, so the cart drawer, its events and any listeners bound to
   * them keep working exactly as they do elsewhere on the site.
   * ---------------------------------------------------------------- */
  function initATC(host) {
    if (host.__bnc) return; host.__bnc = true;
    var btn = $('button,[role="button"],a', host) || host;
    btn.addEventListener('click', function (e) {
      var form = host.closest('form[action*="/cart/add"]');
      var id = (form && form.querySelector('[name="id"]')) ||
               $('[name="id"]', host) || $('[data-variant-id]', host);
      var vid = id ? (id.value || id.getAttribute('data-variant-id')) : host.getAttribute('data-variant-id');
      if (!vid) return;                       // real form present: let it submit
      e.preventDefault();
      var fd = new FormData();
      fd.append('id', vid); fd.append('quantity', 1);
      if (typeof window.addToCartAjax === 'function') { window.addToCartAjax(fd, btn); return; }
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:open'));
        });
    });
  }

  var ROLES = {
    carousel: initCarousel, marquee: initMarquee, accordion: initAccordion,
    tab: initTabs, dialog: initDialog, youtube: initYouTube, atc: initATC
  };


  /* ---------------------------------------------------------------- *
   * Builder slider tracks: native swipe + drag + optional autoplay.
   * The track is already a scroll-snap container in CSS, so touch swipe
   * and trackpad work with no JS. This adds mouse drag, which browsers
   * do not provide, and a slow auto-advance that yields to the reader.
   * ---------------------------------------------------------------- */
  var AUTOPLAY_MS = 3000;

  function initSliderTrack(t) {
    if (t.__bncTrack) return; t.__bncTrack = true;

    // Load every slide's media up front. An IntersectionObserver never fires
    // for slides parked off to the right inside a horizontally-clipped track:
    // they are outside the scroll container, not below the fold. The result is
    // a slide that renders its alt text instead of its image the moment the
    // carousel advances to it. Galleries hold a handful of images, so eager
    // loading here is cheap and removes the failure mode entirely.
    [].forEach.call(t.querySelectorAll('[data-src]:not([data-bnc-loaded]),[data-srcset]:not([data-bnc-loaded])'), swapMedia);

    var slides = function () { return $$(':scope > *', t); };
    var index = function () {
      var best = 0, d = Infinity;
      slides().forEach(function (s, i) {
        var x = Math.abs(s.offsetLeft - t.offsetLeft - t.scrollLeft);
        if (x < d) { d = x; best = i; }
      });
      return best;
    };
    var go = function (i, smooth) {
      var s = slides(); if (!s.length) return;
      i = (i + s.length) % s.length;
      if (!s[i]) return;
      // Flag programmatic movement. Auto-advance emits scroll events and the
      // scroll handler pauses autoplay — without this the first tick silences
      // the carousel permanently.
      t.__bncProgrammatic = true;
      clearTimeout(t.__bncProgT);
      t.__bncProgT = setTimeout(function () { t.__bncProgrammatic = false; }, 900);
      t.scrollTo({ left: s[i].offsetLeft - t.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    };

    // mouse drag (touch is native and better left alone)
    var down = false, moved = false, x0 = 0, l0 = 0, pid = null;
    t.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button !== 0) return;
      down = true; moved = false; pid = e.pointerId; x0 = e.clientX; l0 = t.scrollLeft;
      t.classList.add('is-grabbing'); t.style.scrollSnapType = 'none'; stop();
    });
    t.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pid) return;
      var dx = e.clientX - x0;
      if (!moved && Math.abs(dx) > 4) { moved = true; try { t.setPointerCapture(pid); } catch (x) {} }
      if (!moved) return;
      e.preventDefault(); t.scrollLeft = l0 - dx;
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      t.addEventListener(ev, function () {
        if (!down) return;
        down = false; t.classList.remove('is-grabbing'); t.style.scrollSnapType = '';
        if (pid !== null) { try { t.releasePointerCapture(pid); } catch (x) {} }
        pid = null; if (moved) go(index());
      });
    });
    t.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    t.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // keyboard
    t.setAttribute('tabindex', t.getAttribute('tabindex') || '0');
    t.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); stop(); go(index() + 1); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); stop(); go(index() - 1); }
    });

    // autoplay — only when there is more than one slide, the reader is not
    // interacting, the tab is visible, and reduced motion is not requested
    var timer = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      if (reduce || timer || slides().length < 2) return;
      timer = setInterval(function () {
        if (document.hidden) return;
        var i = index(), n = slides().length;
        go(i + 1 >= n ? 0 : i + 1);
      }, AUTOPLAY_MS);
    }
    // Interaction PAUSES rather than stops. Stopping outright meant the first
    // swipe killed auto-advance for the rest of the session, because the only
    // restart paths were mouseleave and an observer threshold crossing that had
    // already happened.
    var resumeT = null;
    function pause() {
      stop();
      clearTimeout(resumeT);
      resumeT = setTimeout(start, 6000);
    }
    ['mouseenter', 'focusin', 'touchstart', 'wheel'].forEach(function (ev) {
      t.addEventListener(ev, pause, { passive: true });
    });
    t.addEventListener('mouseleave', function () { clearTimeout(resumeT); resumeT = setTimeout(start, 800); });
    t.addEventListener('scroll', function () { if (!t.__bncProgrammatic) pause(); }, { passive: true });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { threshold: 0.25 }).observe(t);
    } else { start(); }
  }

  /* ---------------------------------------------------------------- *
   * Sticky ATC anchor bar: reveal on scroll, smooth-scroll to the
   * product module. Falls back to the href anchor with no JS.
   * ---------------------------------------------------------------- */
  function initStickyATC() {
    var bar = $('[data-bn-sticky-atc]');
    if (!bar || bar.__bnc) return; bar.__bnc = true;
    bar.removeAttribute('hidden');

    var target = $('#bn-buy') || $('.bn-pm') || $('[data-bn="product"]') || $('form[action*="/cart/add"]');
    var cta = $('[data-bn-scroll-to]', bar);
    if (cta && target) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    // Hide once the product module itself is on screen — the bar exists to get
    // the reader there, so it is noise once they have arrived.
    var atTarget = false;
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { atTarget = en.isIntersecting; sync(); });
      }, { threshold: 0.2 }).observe(target);
    }
    function sync() {
      var h = document.body.scrollHeight - window.innerHeight;
      var pct = h > 0 ? (window.scrollY / h) * 100 : 0;
      bar.classList.toggle('is-visible', pct > 12 && !atTarget);
    }
    window.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  function init() {
    $$('[data-bn-role]').forEach(function (el) {
      var fn = ROLES[el.getAttribute('data-bn-role')];
      if (fn) { try { fn(el); } catch (e) {} }
    });
    initLazy();
    $$('.gem-slider, .gem-slider-wrapper').forEach(initSliderTrack);
    initStickyATC();
    initMarqueeTracks();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  window.addEventListener('load', function () {
    init();
    setTimeout(loadRemaining, 1200);
    setTimeout(loadRemaining, 4000);
  }, { once: true });
})();
